import µ from "../earth/1.0.0/micro";
import {useCallback, useEffect, useRef, useState} from "react";
import * as d3 from "d3";
import _ from "lodash";

const CanvasList = ({earthController, setClimateData, clearMouseModeAction, setClearMouseModeAction}) => {
    const point = useRef([]);
    const handleClickCanvas =  (e) => {
        d3.select("#scale_label").style("display", 'none'); //모바일화면에서 컬러바의 범례풍선을 없애는 작업이다.범례풍선을 닫을 방법이 없어 컬러바가 아닌 다른곳을 클릭했을시 닫도록 했다.
        if (!earthController.isInsideBoundary([e.clientX, e.clientY])) return; //필드 외부의 클릭은 동작없음
        point.current.push([e.clientX, e.clientY]);
        //location을 그리는 과정을 위한 이벤트 호출
        earthController.inputController.trigger("click", [e.clientX, e.clientY], earthController.inputController.globe().projection.invert([e.clientX, e.clientY]) || []);
        if (earthController.configuration.get("crossSectionMode")) { //연직단면 모드
            if (earthController.configuration.get("overlayType") !== 'default' && earthController.configuration.get("overlayType") !== 'temp' && earthController.configuration.get("overlayType") !== 'wind') {
                point.current = [];
                return;
            }
            if (point.current.length === 2) {
                const coords = [earthController.inputController.globe().projection.invert(point.current[0]) || [], earthController.inputController.globe().projection.invert(point.current[1]) || []];
                //연직단면 데이터 로드
                var promise = new window.Promise(function (resolve, reject) {
                    resolve(loadCrossSectionData(coords));
                });
                promise.then(function (climateData) {
                    setClimateData(climateData);
                });
                if (earthController.configuration.get("projection") !== "orthographic") point.current = [];
            } else if (point.current.length === 3) { //orthographic프로젝션에서 연직단면 표출 후 한번 더 클릭했을때 초기화 하기 위함
                // earthController.clearLocationDetailsCrossSection(true);
                point.current = [];
            }
        } else if (earthController.configuration.get("areaMeanMode")) { //영역평균 모드
            if (point.current.length === 2) {
                const coords = [earthController.inputController.globe().projection.invert(point.current[0]) || [], earthController.inputController.globe().projection.invert(point.current[1]) || []];

                //영역평균 데이터 로드
                var promise = new window.Promise(function (resolve, reject) {
                    resolve(loadAreaMeanData(coords));
                });
                promise.then(function (climateData) {
                    setClimateData(climateData);
                });
            } else if (point.current.length === 3) { //영역평균 표출 후 한번 더 클릭했을때 초기화 하기 위함
                // earthController.clearLocationDetailsAreaMean(true);
                point.current = [];
            }
        } else { //기본모드
            //클릭한 지점의 20년 평균 데이터를 가져온다
            var promise = new window.Promise(function (resolve, reject) {
                resolve(loadAverageVicennialTimeSeriesData(earthController.inputController.globe().projection.invert([e.clientX, e.clientY]) || []));
            });
            promise.then(function (climateData) {
                setClimateData(climateData);
                point.current = [];
            });
        }
    };

    useEffect(() => {
        if (earthController.configuration) {
            point.current = [];
            setClimateData(null);
            setClearMouseModeAction(false);
        }
    }, [earthController, clearMouseModeAction])

    function loadAverageVicennialTimeSeriesData(coord) {
        if (coord.length === 0) return;
        var params = "/" + µ.isMobile()
            + "/" + earthController.configuration.get("date").replace(/\//gi, "-")
            + "/" + ((earthController.configuration.get("date") === "current") ? "0000" : earthController.configuration.get("hour"))
            + "/" + earthController.configuration.get("param")
            + "/" + earthController.configuration.get("surface")
            + "/" + earthController.configuration.get("level")
            + "/overlay=" + earthController.configuration.get("overlayType")
            + "/" + coord[0]
            + "/" + coord[1]
            + "/" + earthController.configuration.get("scenario");
        return µ.loadJson(µ.timeseriesAvgVicennial + params).then(function (climateData) {
            // log.timeEnd("loading average vicennial time series");
            return climateData;
        });
    }

    function loadCrossSectionData(coords) {
        let currentScenario = earthController.configuration.get("scenario");
        if (earthController.configuration.get("date") !== 'current') {
            const currentDate = earthController.configuration.get("date").split('/')[0];
            if (Number(currentDate) < 2015) currentScenario = 'hist';
        }
        const params = earthController.configuration.get("date").replace(/\//gi, "-")
            + "/" + ((earthController.configuration.get("date") === "current") ? "0000" : earthController.configuration.get("hour"))
            + "/" + earthController.configuration.get("param")
            + "/" + earthController.configuration.get("surface")
            + "/" + earthController.configuration.get("level")
            + "/overlay=" + earthController.configuration.get("overlayType")
            + "/" + coords[0][0].toFixed(3)
            + "/" + coords[0][1].toFixed(3)
            + "/" + coords[1][0].toFixed(3)
            + "/" + coords[1][1].toFixed(3)
            + "/" + currentScenario;
        let path = [µ.crossSection, params].join("/");
        return µ.loadJson(path).then(function (crossSectionData) {
            return crossSectionData;
        });
    }

    function loadAreaMeanData(coords) {
        const params = earthController.configuration.get("date").replace(/\//gi, "-")
            + "/" + ((earthController.configuration.get("date") === "current") ? "0000" : earthController.configuration.get("hour"))
            + "/" + earthController.configuration.get("param")
            + "/" + earthController.configuration.get("surface")
            + "/" + earthController.configuration.get("level")
            + "/overlay=" + earthController.configuration.get("overlayType")
            + "/" + coords[0][0].toFixed(3)
            + "/" + coords[0][1].toFixed(3)
            + "/" + coords[1][0].toFixed(3)
            + "/" + coords[1][1].toFixed(3)
            + "/" + earthController.configuration.get("scenario");
        let path = [µ.areaMean, params].join("/");
        return µ.loadJson(path).then(function (areaMeanData) {
            return areaMeanData;
        });
    }

    return (
        <div id="display">
            <canvas id="map" className="fit-screen"></canvas>
            <canvas id="contour" className="fill-screen"></canvas>
            <canvas id="contourLabel" className="fill-screen"></canvas>
            <canvas id="foreground" className="fill-screen"></canvas>
            <canvas id="earthImage" className="fill-screen"></canvas>
            <canvas id="animation" className="fill-screen"></canvas>
            <canvas id="quickoverlay" className="fill-screen"></canvas>
            <canvas id="overlay" className="fill-screen"></canvas>
            <canvas id="windVector" className="fill-screen"></canvas>
            <canvas id="rec" className="fill-screen"></canvas>
            {/*<canvas id="crossSection2d" className="fill-screen"></canvas>*/}
            <canvas id="locationpoint" className="fill-screen" onClick={handleClickCanvas}></canvas>
            {/*<svg id="areaMean" xmlns="http://www.w3.org/2000/svg" version="1.1"></svg>*/}
        </div>
    );
}

export default CanvasList;